import { apiAddress } from '../ApiPlatform';

export const API_SELECT_SIDO_LIST = apiAddress + '/common/selectSido';
export const API_SELECT_SIGU_LIST = apiAddress + '/common/selectSigu';
export const API_SELECT_DONG_LIST = apiAddress + '/common/selectDong';

export const API_UPDATE_FEES = apiAddress + '/common/feesUpdate';
